import styled, { theme } from 'academy-common-lib/utils/Styling';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Header } from 'foundations-components/transitional/components/Header';
import { PlayerPlayIcon } from 'foundations-assets';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { View } from 'foundations-components/components/View';
import UsageTracker from '../../../../utils/UsageTracker';
import LearnWhileDoingButton from '../LearnByDoing/LearnByDoingButton';
import { useRequestLearnWhileDoing } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FontColor = styled.div.withConfig({
  displayName: "LearnByDoingCTAScreen__FontColor",
  componentId: "sc-1anatl4-0"
})(["color:", " !important;padding-bottom:20px;div{display:block;}"], theme.colors.OLAF);
const LearnByDoingCtaScreenStyle = styled.div.withConfig({
  displayName: "LearnByDoingCTAScreen__LearnByDoingCtaScreenStyle",
  componentId: "sc-1anatl4-1"
})(["position:relative;margin-bottom:-150px;"]);
const LearnByDoingCtaButtonContainer = styled.div.withConfig({
  displayName: "LearnByDoingCTAScreen__LearnByDoingCtaButtonContainer",
  componentId: "sc-1anatl4-2"
})(["background-color:", ";bottom:150px;position:relative;"], theme.colors.OBSIDIAN);
const LearnByDoingCtaScreen = ({
  backgroundImage,
  otgId
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const {
    handlePlayHsVideo,
    handleDisableLearnWhileDoingScreen,
    isVideoPlayed,
    isVideoFinished
  } = useRequestLearnWhileDoing();
  const handlePlayInAcademy = () => {
    handlePlayHsVideo();
    handleDisableLearnWhileDoingScreen();
    UsageTracker.track('contentInteraction', {
      action: 'learn-by-doing-cta-play-in-academy-clicked',
      shortId: String(otgId),
      contentId: String(otgId)
    });
  };
  return /*#__PURE__*/_jsx(LearnByDoingCtaScreenStyle, {
    "data-test-id": "learn-by-doing-cta-screen",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Image, {
        alt: "learn-by-doing-cta-screen",
        onLoad: () => setImgLoaded(true),
        src: backgroundImage
      }), imgLoaded ? /*#__PURE__*/_jsx(LearnByDoingCtaButtonContainer, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          paddingBlock: "500",
          children: [/*#__PURE__*/_jsx(FontColor, {
            children: /*#__PURE__*/_jsxs("center", {
              children: [/*#__PURE__*/_jsx(Header, {
                paddingBlock: "300",
                title: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.learnByDoing.learnByDoingHeading"
                }),
                use: "condensed"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.learnByDoing.subTextLearnByDoing"
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            children: [/*#__PURE__*/_jsx(LearnWhileDoingButton, {
              otgId: otgId
            }), /*#__PURE__*/_jsx(Button, {
              "data-test-id": "play-in-academy-button",
              onClick: handlePlayInAcademy,
              size: "medium",
              use: "secondary-ghost",
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                flexDirection: "row",
                gap: "200",
                children: [!isVideoFinished && isVideoPlayed ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.learnByDoing.continueHere"
                }) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.learnByDoing.watchInAcademy"
                }), /*#__PURE__*/_jsx(IconCircle, {
                  backgroundColor: 'fill-accent-orange-default',
                  borderWidth: '0',
                  icon: PlayerPlayIcon,
                  padding: "100",
                  size: '100'
                })]
              })
            })]
          })]
        })
      }) : /*#__PURE__*/_jsx(View, {
        blockSize: "600px",
        children: /*#__PURE__*/_jsx(LoadingOverlay, {
          contextual: true,
          layout: "centered",
          padding: "1700",
          use: "spinner"
        })
      })]
    })
  });
};
export default LearnByDoingCtaScreen;